module.exports = __webpack_public_path__ + "img/logo-comune_ext.d573e408.png";